if (!customElements.get('m2-calculator')) {
  customElements.define(
    'm2-calculator',
    class M2Calculator extends HTMLElement {
      connectedCallback() {
        this.m2Input = this.querySelector('[data-m2-input]');
        this.wasteInput = this.querySelector('[data-waste-input]');
        this.requestedAreaOutput = this.querySelector('[data-requested-area]');
        this.adjustedAreaOutput = this.querySelector('[data-adjusted-area]');
        this.packCountOutput = this.querySelector('[data-pack-count]');
        this.deliveredAreaOutput = this.querySelector('[data-delivered-area]');
        this.billableAreaOutput = this.querySelector('[data-billable-area]');
        this.packCountNote = this.querySelector('[data-pack-count-note]');
        this.deliveredAreaNote = this.querySelector('[data-delivered-area-note]');
        this.billableAreaNote = this.querySelector('[data-billable-area-note]');
        this.m2PerPackNote = this.querySelector('[data-m2-per-pack-note]');
        this.packSummaryOutput = this.querySelector('[data-pack-summary]');
        this.billableExplainerOutput = this.querySelector('[data-billable-explainer]');
        this.subtotalOutput = this.querySelector('[data-subtotal]');
        this.pricePerM2Output = this.querySelector('[data-price-per-m2]');
        this.optionsTotalOutput = this.querySelector('[data-options-total]');
        this.deliveryTotalOutput = this.querySelector('[data-delivery-total]');
        this.grandTotalOutput = this.querySelector('[data-grand-total]');
        this.installationTotalOutput = this.querySelector('[data-installation-total]');
        this.levelingTotalOutput = this.querySelector('[data-leveling-total]');
        this.skirtingTotalOutput = this.querySelector('[data-skirting-total]');
        this.sealingTotalOutput = this.querySelector('[data-sealing-total]');
        this.selectedOptionsSummaryOutput = this.querySelector('[data-selected-options-summary]');
        this.serviceStatusOutput = this.querySelector('[data-service-status]');
        this.deliveryStatusOutput = this.querySelector('[data-delivery-status]');
        this.selectedFloorVariantOutput = this.querySelector('[data-selected-floor-variant]');
        this.heatingInput = this.querySelector('[data-heating-input]');
        this.installationInput = this.querySelector('[data-installation-input]');
        this.levelingInput = this.querySelector('[data-leveling-input]');
        this.skirtingInput = this.querySelector('[data-skirting-input]');
        this.sealingInput = this.querySelector('[data-sealing-input]');
        this.deliveryInput = this.querySelector('[data-delivery-input]');
        this.deliveryPlacementInput = this.querySelector('[data-delivery-placement-input]');
        this.deliveryDetails = this.querySelector('[data-delivery-details]');
        this.skirtingFields = this.querySelector('[data-skirting-fields]');
        this.skirtingQuantityField = this.querySelector('[data-skirting-quantity-field]');
        this.skirtingRoomLengthInput = this.querySelector('[data-skirting-room-length-input]');
        this.skirtingRoomWidthInput = this.querySelector('[data-skirting-room-width-input]');
        this.skirtingQuantityInput = this.querySelector('[data-skirting-quantity-input]');
        this.skirtingCalculationNote = this.querySelector('[data-skirting-calculation-note]');
        this.skirtingCalculationBadge = this.querySelector('[data-skirting-calculation-badge]');
        this.stairsField = this.querySelector('[data-stairs-field]');
        this.stairsInput = this.querySelector('[data-stairs-input]');
        this.m2PerPackLabel = this.querySelector('[data-m2-per-pack-label]');
        this.errorMessage = this.querySelector('[data-m2-error]');
        this.packErrorMessage = this.querySelector('[data-m2-pack-error]');
        this.serviceErrorMessage = this.querySelector('[data-m2-service-error]');
        this.propertyRequestedArea = this.querySelector('[data-property-requested-area]');
        this.propertyWaste = this.querySelector('[data-property-waste]');
        this.propertyAdjustedArea = this.querySelector('[data-property-adjusted-area]');
        this.propertyBillableArea = this.querySelector('[data-property-billable-area]');
        this.propertyPacks = this.querySelector('[data-property-packs]');
        this.propertyM2PerPack = this.querySelector('[data-property-m2-per-pack]');
        this.propertyDeliveredArea = this.querySelector('[data-property-delivered-area]');
        this.propertyHeating = this.querySelector('[data-property-heating]');
        this.propertyInstallation = this.querySelector('[data-property-installation]');
        this.propertyLeveling = this.querySelector('[data-property-leveling]');
        this.propertySkirting = this.querySelector('[data-property-skirting]');
        this.propertySealing = this.querySelector('[data-property-sealing]');
        this.propertyDelivery = this.querySelector('[data-property-delivery]');
        this.propertyDeliveryPlacement = this.querySelector('[data-property-delivery-placement]');
        this.propertyStairs = this.querySelector('[data-property-stairs]');
        this.propertyFloorTotal = this.querySelector('[data-property-floor-total]');
        this.propertyInstallationTotal = this.querySelector('[data-property-installation-total]');
        this.propertyLevelingTotal = this.querySelector('[data-property-leveling-total]');
        this.propertySkirtingTotal = this.querySelector('[data-property-skirting-total]');
        this.propertySealingTotal = this.querySelector('[data-property-sealing-total]');
        this.propertyOptionsTotal = this.querySelector('[data-property-options-total]');
        this.propertyDeliveryTotal = this.querySelector('[data-property-delivery-total]');
        this.propertyGrandTotal = this.querySelector('[data-property-grand-total]');
        this.variantM2PerPackMap = this.parseVariantM2PerPackMap();
        this.productForm = document.getElementById(this.dataset.productFormId);
        this.fallbackQuantityInput = document.getElementById(this.dataset.fallbackQuantityInputId);
        this.visibleQuantityInput = document.getElementById(this.dataset.quantityInputId);
        this.quantityInput = this.visibleQuantityInput || this.fallbackQuantityInput;
        this.submitButton = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
        this.paymentButton = this.productForm?.querySelector('.shopify-payment-button');
        this.submitButtonInitiallyDisabled = this.submitButton?.hasAttribute('disabled') || false;

        this.prepareQuantityInput();

        this.m2PerPack = this.parseM2PerPack(this.dataset.m2PerPack);
        this.wastePercentage = parseFloat(this.dataset.wastePercentage) || 15;
        this.pricePerM2Cents = parseInt(this.dataset.pricePerM2Cents, 10) || 0;
        this.installationCentsPerM2 = 3000;
        this.levelingCentsPerM2 = 2200;
        this.skirtingMatchingCents = 450;
        this.skirtingModernCents = 1300;
        this.sealingCentsPerM2 = 0;
        this.deliveryCents = 25000;
        this.freeDeliveryThresholdCents = 100100;
        this.stairCents = 5000;
        this.isAddingToCart = false;
        this.serviceProducts = {
          installation: {
            handle: this.dataset.installationProductHandle,
            priceCents: this.dataset.installationPriceCents,
            variantId: this.dataset.installationVariantId,
          },
          leveling: {
            handle: this.dataset.levelingProductHandle,
            priceCents: this.dataset.levelingPriceCents,
            variantId: this.dataset.levelingVariantId,
          },
          skirtingMatching: {
            handle: this.dataset.skirtingMatchingProductHandle,
            priceCents: this.dataset.skirtingMatchingPriceCents,
            variantId: this.dataset.skirtingMatchingVariantId,
          },
          skirtingModern: {
            handle: this.dataset.skirtingModernProductHandle,
            priceCents: this.dataset.skirtingModernPriceCents,
            variantId: this.dataset.skirtingModernVariantId,
          },
          sealing: {
            handle: this.dataset.sealingProductHandle,
            priceCents: this.dataset.sealingPriceCents,
            variantId: this.dataset.sealingVariantId,
          },
          delivery: {
            handle: this.dataset.deliveryProductHandle,
            priceCents: this.dataset.deliveryPriceCents,
            variantId: this.dataset.deliveryVariantId,
          },
          stairs: {
            handle: this.dataset.stairsProductHandle,
            priceCents: this.dataset.stairsPriceCents,
            variantId: this.dataset.stairsVariantId,
          },
        };
        this.currency = this.dataset.currency || 'EUR';
        this.locale = this.dataset.locale || document.documentElement.lang || 'nl-NL';

        this.onInputChange = this.updateCalculator.bind(this);
        this.onFormSubmit = this.validateBeforeSubmit.bind(this);

        this.bindInputListeners();

        this.productForm?.addEventListener('submit', this.onFormSubmit, true);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data?.sectionId !== this.dataset.sectionId || !event.data?.variant) return;
            this.pricePerM2Cents = event.data.variant.price || 0;
            this.updateM2PerPackForVariant(event.data.variant.id);
            if (this.selectedFloorVariantOutput && event.data.variant.title && event.data.variant.title !== 'Default Title') {
              this.selectedFloorVariantOutput.textContent = event.data.variant.title;
            }
            this.updateCalculator({ updateQuantity: false });
          });
        }

        this.updateM2PerPackDisplay();
        this.applyServicePrices();
        this.updateCalculator({ updateQuantity: false });
        requestAnimationFrame(() => this.updateCalculator({ updateQuantity: false }));
      }

      disconnectedCallback() {
        this.unbindInputListeners();
        this.productForm?.removeEventListener('submit', this.onFormSubmit, true);
        this.variantChangeUnsubscriber?.();
      }

      bindInputListeners() {
        this.boundInputListeners = [];

        [
          [this.m2Input, ['input', 'change', 'keyup', 'blur']],
          [this.wasteInput, ['change']],
          [this.heatingInput, ['change']],
          [this.installationInput, ['change']],
          [this.levelingInput, ['change']],
          [this.skirtingInput, ['change']],
          [this.skirtingRoomLengthInput, ['input', 'change']],
          [this.skirtingRoomWidthInput, ['input', 'change']],
          [this.sealingInput, ['change']],
          [this.deliveryInput, ['change']],
          [this.deliveryPlacementInput, ['change']],
          [this.stairsInput, ['input', 'change']],
        ].forEach(([input, events]) => {
          if (!input) return;
          events.forEach((eventName) => {
            input.addEventListener(eventName, this.onInputChange);
            this.boundInputListeners.push({ input, eventName });
          });
        });
      }

      unbindInputListeners() {
        this.boundInputListeners?.forEach(({ input, eventName }) => {
          input.removeEventListener(eventName, this.onInputChange);
        });
        this.boundInputListeners = [];
      }

      updateCalculator(options = {}) {
        const updateQuantity = options.updateQuantity !== false;
        const area = Math.max(parseFloat(this.m2Input?.value.replace(',', '.')) || 0, 0);
        const hasValidArea = area > 0;
        const hasValidM2PerPack = this.isValidM2PerPack();
        const wasteFactor = this.wasteInput?.checked ? 1 + this.wastePercentage / 100 : 1;
        const adjustedArea = area * wasteFactor;
        const packs = adjustedArea > 0 && hasValidM2PerPack ? Math.ceil(adjustedArea / this.m2PerPack) : 0;
        const deliveredArea = packs * this.m2PerPack;
        const rawBillableArea = deliveredArea > 0 ? Math.ceil(deliveredArea) : 0;
        const billableArea = rawBillableArea ? this.applyQuantityRules(rawBillableArea) : 0;
        // Services follow the originally requested area and do not include snijverlies.
        const serviceArea = area > 0 ? Math.ceil(area) : 0;
        const floorSubtotalCents = billableArea * this.pricePerM2Cents;
        const extraCosts = this.calculateExtraCosts(serviceArea, floorSubtotalCents);
        this.currentCalculation = {
          area,
          adjustedArea,
          billableArea,
          deliveredArea,
          serviceArea,
          extraCosts,
          floorSubtotalCents,
          packs,
        };

        this.setText(this.requestedAreaOutput, this.formatNumber(area));
        this.setText(this.adjustedAreaOutput, this.formatNumber(adjustedArea));
        this.setText(this.packCountOutput, packs);
        this.setText(this.deliveredAreaOutput, this.formatNumber(deliveredArea));
        this.setText(this.billableAreaOutput, billableArea);
        this.setText(this.packCountNote, packs);
        this.setText(this.deliveredAreaNote, this.formatNumber(deliveredArea));
        this.setText(this.billableAreaNote, billableArea);
        this.setText(this.m2PerPackNote, this.formatNumber(this.m2PerPack));
        this.setText(this.packSummaryOutput, this.buildPackSummary(packs, deliveredArea));
        this.setText(this.billableExplainerOutput, this.buildBillableExplainer(billableArea, adjustedArea, deliveredArea));
        this.setText(this.pricePerM2Output, this.formatMoney(this.pricePerM2Cents));
        this.setText(this.subtotalOutput, this.formatMoney(floorSubtotalCents));
        this.setText(this.installationTotalOutput, this.formatMoney(extraCosts.installationCents));
        this.setText(this.levelingTotalOutput, this.formatMoney(extraCosts.levelingCents));
        this.setText(this.skirtingTotalOutput, this.formatMoney(extraCosts.skirtingTotalCents));
        this.setText(this.sealingTotalOutput, this.formatMoney(extraCosts.sealingCents));
        this.setText(this.optionsTotalOutput, this.formatMoney(extraCosts.optionsTotalCents));
        this.setText(this.deliveryTotalOutput, this.formatMoney(extraCosts.deliveryTotalCents));
        this.setText(this.grandTotalOutput, this.formatMoney(extraCosts.grandTotalCents));
        this.setText(this.selectedOptionsSummaryOutput, this.buildSelectedOptionsSummary(extraCosts));
        this.setText(this.serviceStatusOutput, this.buildServiceStatus());
        this.setText(this.deliveryStatusOutput, this.buildDeliveryStatus(extraCosts));
        this.updateExtraOptionVisibility();
        this.setServiceError(false);
        this.updateLineItemProperties(area, adjustedArea, billableArea, packs, deliveredArea, floorSubtotalCents, extraCosts);
        this.updateSubmitState(hasValidArea && hasValidM2PerPack, {
          showAreaError: false,
          showPackError: !hasValidM2PerPack,
        });

        if (updateQuantity && this.quantityInput) {
          const quantity = billableArea || this.quantityInput.min || 1;
          this.quantityInput.value = quantity;
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      prepareQuantityInput() {
        if (!this.fallbackQuantityInput) return;

        if (this.visibleQuantityInput) {
          this.fallbackQuantityInput.disabled = true;
          this.fallbackQuantityInput.removeAttribute('name');
          return;
        }

        if (!this.productForm) return;

        this.fallbackQuantityInput.disabled = false;
        this.fallbackQuantityInput.setAttribute('name', 'quantity');
        if (!this.productForm.contains(this.fallbackQuantityInput)) {
          this.productForm.appendChild(this.fallbackQuantityInput);
        }
      }

      parseVariantM2PerPackMap() {
        const mapScript = this.querySelector('[data-m2-variant-map]');

        if (!mapScript?.textContent) return {};

        try {
          return JSON.parse(mapScript.textContent);
        } catch (error) {
          console.warn('Could not parse m2 per pack variant map:', error);
          return {};
        }
      }

      parseM2PerPack(value) {
        const m2PerPack = parseFloat(String(value || '').replace(',', '.'));
        return !m2PerPack || Number.isNaN(m2PerPack) ? 0 : m2PerPack;
      }

      isValidM2PerPack() {
        return this.m2PerPack > 0 && !Number.isNaN(this.m2PerPack);
      }

      updateM2PerPackForVariant(variantId) {
        const variantKey = String(variantId);

        if (!Object.prototype.hasOwnProperty.call(this.variantM2PerPackMap, variantKey)) return;

        const variantM2PerPack = this.variantM2PerPackMap[variantKey];
        this.dataset.m2PerPack = variantM2PerPack;
        this.m2PerPack = this.parseM2PerPack(variantM2PerPack);
        this.updateM2PerPackDisplay();
      }

      updateM2PerPackDisplay() {
        const formattedM2PerPack = this.formatNumber(this.m2PerPack);

        this.setText(this.m2PerPackLabel, formattedM2PerPack);
        this.setText(this.m2PerPackNote, formattedM2PerPack);

        if (this.propertyM2PerPack) {
          this.propertyM2PerPack.value = `${formattedM2PerPack} m²`;
        }
      }

      calculateExtraCosts(serviceArea, floorSubtotalCents) {
        const installationCents = this.installationInput?.value === 'yes' ? serviceArea * this.installationCentsPerM2 : 0;
        const levelingCents = this.levelingInput?.value === 'yes' ? serviceArea * this.levelingCentsPerM2 : 0;
        const skirtingQuantity = this.getSkirtingQuantity();
        const skirtingUnitCents = this.getSkirtingUnitCents();
        const skirtingBaseCents = skirtingQuantity * skirtingUnitCents;
        const skirtingTotalCents = skirtingBaseCents;
        const sealingCents = this.sealingInput?.value === 'yes' ? serviceArea * this.sealingCentsPerM2 : 0;
        const optionsTotalCents =
          installationCents + levelingCents + skirtingTotalCents + sealingCents;
        const deliveryBaseCents =
          this.deliveryInput?.value === 'delivery' && floorSubtotalCents + optionsTotalCents < this.freeDeliveryThresholdCents
            ? this.deliveryCents
            : 0;
        const stairs = this.deliveryPlacementInput?.value === 'inside' ? this.getStairCount() : 0;
        const stairDeliveryCents = this.deliveryInput?.value === 'delivery' ? stairs * this.stairCents : 0;
        const deliveryTotalCents = this.deliveryInput?.value === 'delivery' ? deliveryBaseCents + stairDeliveryCents : 0;
        const grandTotalCents = floorSubtotalCents + optionsTotalCents + deliveryTotalCents;

        return {
          serviceArea,
          installationCents,
          levelingCents,
          skirtingBaseCents,
          skirtingTotalCents,
          skirtingQuantity,
          skirtingUnitCents,
          sealingCents,
          deliveryBaseCents,
          stairDeliveryCents,
          deliveryTotalCents,
          optionsTotalCents,
          grandTotalCents,
          stairs,
        };
      }

      updateExtraOptionVisibility() {
        const showDeliveryDetails = this.deliveryInput?.value === 'delivery';
        const showStairs = showDeliveryDetails && this.deliveryPlacementInput?.value === 'inside';
        const showSkirtingFields = this.skirtingInput?.value === 'matching' || this.skirtingInput?.value === 'modern';

        this.updateSkirtingCalculation();

        if (this.deliveryDetails) {
          this.deliveryDetails.hidden = !showDeliveryDetails;
        }

        if (this.skirtingFields) {
          this.skirtingFields.hidden = !showSkirtingFields;
        }

        if (this.skirtingQuantityField) {
          this.skirtingQuantityField.hidden = !showSkirtingFields;
        }

        if (this.stairsField) {
          this.stairsField.hidden = !showStairs;
        }
      }

      getSkirtingQuantity() {
        if (this.skirtingInput?.value !== 'matching' && this.skirtingInput?.value !== 'modern') return 0;
        return Math.max(parseInt(this.skirtingQuantityInput?.value || '0', 10) || 0, 0);
      }

      getSkirtingRoomDimension(input) {
        return Math.max(parseFloat(input?.value?.replace(',', '.')) || 0, 0);
      }

      getEstimatedSkirtingData() {
        const area = Math.max(parseFloat(this.m2Input?.value?.replace(',', '.')) || 0, 0);

        if (!area) {
          return {
            perimeter: 0,
            quantity: 0,
            source: 'none',
          };
        }

        const estimatedSide = Math.sqrt(area);
        const estimatedPerimeter = estimatedSide * 4;

        return {
          perimeter: estimatedPerimeter,
          quantity: Math.ceil(estimatedPerimeter / 2.4),
          source: 'estimate',
        };
      }

      updateSkirtingCalculation() {
        const usesSkirting = this.skirtingInput?.value === 'matching' || this.skirtingInput?.value === 'modern';
        const roomLength = this.getSkirtingRoomDimension(this.skirtingRoomLengthInput);
        const roomWidth = this.getSkirtingRoomDimension(this.skirtingRoomWidthInput);

        if (!usesSkirting) {
          if (this.skirtingQuantityInput) this.skirtingQuantityInput.value = 0;
          this.setText(this.skirtingCalculationBadge, 'Schatting');
          this.setText(this.skirtingCalculationNote, 'Kies een plint om een automatische schatting te zien.');
          return;
        }

        if (roomLength && roomWidth) {
          const perimeter = (roomLength + roomWidth) * 2;
          const skirtingQuantity = Math.ceil(perimeter / 2.4);

          if (this.skirtingQuantityInput) this.skirtingQuantityInput.value = skirtingQuantity;
          this.setText(this.skirtingCalculationBadge, 'Exactere berekening');
          this.setText(
            this.skirtingCalculationNote,
            `Exact op basis van ${this.formatNumber(perimeter)} m omtrek -> advies ${skirtingQuantity} lengtes van 2,40 m.`
          );
          return;
        }

        const estimatedSkirting = this.getEstimatedSkirtingData();

        if (this.skirtingQuantityInput) this.skirtingQuantityInput.value = estimatedSkirting.quantity;

        if (!estimatedSkirting.quantity) {
          this.setText(this.skirtingCalculationBadge, 'Schatting');
          this.setText(this.skirtingCalculationNote, 'Vul eerst het aantal m² in om een plintschatting te krijgen.');
          return;
        }

        this.setText(this.skirtingCalculationBadge, 'Schatting');
        this.setText(
          this.skirtingCalculationNote,
          `Schatting op basis van ${this.formatNumber(Math.max(parseFloat(this.m2Input?.value?.replace(',', '.')) || 0, 0))} m² -> ongeveer ${estimatedSkirting.quantity} lengtes van 2,40 m. Vul lengte en breedte in voor een exactere berekening.`
        );
      }

      getSkirtingUnitCents() {
        if (this.skirtingInput?.value === 'matching') return this.skirtingMatchingCents;
        if (this.skirtingInput?.value === 'modern') return this.skirtingModernCents;
        return 0;
      }

      getStairCount() {
        return Math.max(parseInt(this.stairsInput?.value || '0', 10) || 0, 0);
      }

      applyQuantityRules(quantity) {
        if (!this.quantityInput || quantity === 0) return quantity;

        const min = parseInt(this.quantityInput.min || this.quantityInput.dataset.min || '1', 10);
        const max = parseInt(this.quantityInput.max || this.quantityInput.dataset.max || '', 10);
        const step = parseInt(this.quantityInput.step || '1', 10);
        let adjustedQuantity = Math.max(quantity, min);

        if (step > 1 && adjustedQuantity > min) {
          adjustedQuantity = min + Math.ceil((adjustedQuantity - min) / step) * step;
        }

        if (!Number.isNaN(max)) adjustedQuantity = Math.min(adjustedQuantity, max);

        return adjustedQuantity;
      }

      validateBeforeSubmit(event) {
        const area = Math.max(parseFloat(this.m2Input?.value.replace(',', '.')) || 0, 0);
        const skirtingSelected = this.skirtingInput?.value === 'matching' || this.skirtingInput?.value === 'modern';
        const hasValidSkirtingCalculation = !skirtingSelected || this.getSkirtingQuantity() > 0;

        if (area > 0 && this.isValidM2PerPack() && hasValidSkirtingCalculation) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setServiceError(false);
          this.addCalculatedItemsToCart(event);
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        this.updateSubmitState(false, {
          showAreaError: area <= 0,
          showPackError: !this.isValidM2PerPack(),
        });

        if (area <= 0) {
          this.m2Input?.focus();
          return;
        }

        if (!hasValidSkirtingCalculation) {
          this.setServiceError(true, 'Vul eerst het aantal m² in om een plintschatting te maken, of geef lengte en breedte van de ruimte op.');
          this.m2Input?.focus();
        }
      }

      updateSubmitState(isValid, options = {}) {
        const showAreaError = options.showAreaError === true;
        const showPackError = options.showPackError === true;

        if (this.submitButton && !this.submitButtonInitiallyDisabled) {
          this.submitButton.disabled = !isValid;
          this.submitButton.toggleAttribute('aria-disabled', !isValid);
        }

        if (this.paymentButton) {
          this.paymentButton.hidden = true;
        }

        if (this.errorMessage) {
          this.errorMessage.hidden = isValid || !showAreaError;
        }

        if (this.packErrorMessage) {
          this.packErrorMessage.hidden = isValid || !showPackError;
        }

        if (this.serviceErrorMessage && isValid) {
          this.serviceErrorMessage.hidden = true;
        }
      }

      updateLineItemProperties(area, adjustedArea, billableArea, packs, deliveredArea, floorSubtotalCents, extraCosts) {
        const hasArea = area > 0;
        const serviceArea = extraCosts.serviceArea || 0;
        const heatingText =
          this.heatingInput?.value === 'yes' ? 'Ja' : this.heatingInput?.value === 'request' ? 'Op aanvraag' : 'Nee';
        const skirtingText = this.getSkirtingText(extraCosts);
        const sealingText =
          this.sealingInput?.value === 'yes'
            ? `Ja - ${this.formatMoney(extraCosts.sealingCents)} (${serviceArea} m² x ${this.formatMoney(this.sealingCentsPerM2)})`
            : 'Nee';
        const deliveryText =
          this.deliveryInput?.value === 'delivery'
            ? `Bezorgen - ${extraCosts.deliveryBaseCents === 0 ? 'basisbezorging gratis vanaf EUR 1.001' : this.formatMoney(extraCosts.deliveryBaseCents)}`
            : 'Afhalen in Groningen - Gratis';
        const deliveryPlacementText =
          this.deliveryInput?.value === 'delivery'
            ? this.deliveryPlacementInput?.value === 'inside'
              ? `Tot binnen + trapservice (${extraCosts.stairs} trappen x ${this.formatMoney(this.stairCents)})`
              : 'Tot de deur'
            : '';
        const installationText =
          this.installationInput?.value === 'yes'
            ? `Ja - ${this.formatMoney(extraCosts.installationCents)} (${serviceArea} m² x ${this.formatMoney(this.installationCentsPerM2)})`
            : 'Nee';
        const levelingText =
          this.levelingInput?.value === 'yes'
            ? `Ja - ${this.formatMoney(extraCosts.levelingCents)} (${serviceArea} m² x ${this.formatMoney(this.levelingCentsPerM2)})`
            : 'Nee';

        this.setProperty(this.propertyRequestedArea, hasArea, `${this.formatNumber(area)} m²`);
        this.setProperty(
          this.propertyWaste,
          hasArea,
          this.getWasteDescription(area, adjustedArea)
        );
        this.setProperty(this.propertyAdjustedArea, hasArea, `${this.formatNumber(adjustedArea)} m²`);
        this.setProperty(this.propertyBillableArea, hasArea, `${billableArea} m²`);
        this.setProperty(this.propertyPacks, hasArea, `${packs}`);
        this.setProperty(this.propertyM2PerPack, hasArea, `${this.formatNumber(this.m2PerPack)} m²`);
        this.setProperty(this.propertyDeliveredArea, hasArea, `${this.formatNumber(deliveredArea)} m²`);
        this.setProperty(this.propertyHeating, hasArea, heatingText);
        this.setProperty(this.propertyInstallation, hasArea, installationText);
        this.setProperty(this.propertyLeveling, hasArea, levelingText);
        this.setProperty(this.propertySkirting, hasArea, skirtingText);
        this.setProperty(this.propertySealing, hasArea, sealingText);
        this.setProperty(this.propertyDelivery, hasArea, deliveryText);
        this.setProperty(this.propertyDeliveryPlacement, hasArea && Boolean(deliveryPlacementText), deliveryPlacementText);
        this.setProperty(this.propertyStairs, hasArea && this.deliveryInput?.value === 'delivery', `${extraCosts.stairs}`);
        this.setProperty(this.propertyFloorTotal, hasArea, this.formatMoney(floorSubtotalCents));
        this.setProperty(this.propertyInstallationTotal, hasArea, this.formatMoney(extraCosts.installationCents));
        this.setProperty(this.propertyLevelingTotal, hasArea, this.formatMoney(extraCosts.levelingCents));
        this.setProperty(this.propertySkirtingTotal, hasArea, this.formatMoney(extraCosts.skirtingTotalCents));
        this.setProperty(this.propertySealingTotal, hasArea, this.formatMoney(extraCosts.sealingCents));
        this.setProperty(this.propertyOptionsTotal, hasArea, this.formatMoney(extraCosts.optionsTotalCents));
        this.setProperty(this.propertyDeliveryTotal, hasArea, this.formatMoney(extraCosts.deliveryTotalCents));
        this.setProperty(this.propertyGrandTotal, hasArea, this.formatMoney(extraCosts.grandTotalCents));
      }

      getWasteDescription(area, adjustedArea) {
        const pieces = [];

        if (this.wasteInput?.checked) {
          pieces.push(`${this.wastePercentage}% standaard snijverlies`);
        }

        if (!pieces.length) return 'Nee';

        return `${pieces.join(' + ')} (${this.formatNumber(area)} m² -> ${this.formatNumber(adjustedArea)} m²)`;
      }

      getSkirtingText(extraCosts) {
        const quantity = this.getSkirtingQuantity();
        const roomLength = this.getSkirtingRoomDimension(this.skirtingRoomLengthInput);
        const roomWidth = this.getSkirtingRoomDimension(this.skirtingRoomWidthInput);
        const estimatedSkirting = this.getEstimatedSkirtingData();
        const perimeter = roomLength && roomWidth ? (roomLength + roomWidth) * 2 : estimatedSkirting.perimeter;
        const calculationSuffix = roomLength && roomWidth
          ? ` op basis van ${this.formatNumber(perimeter)} m omtrek`
          : estimatedSkirting.quantity > 0
            ? ` als schatting op basis van ${this.formatNumber(Math.max(parseFloat(this.m2Input?.value?.replace(',', '.')) || 0, 0))} m²`
            : '';

        if ((this.skirtingInput?.value === 'matching' || this.skirtingInput?.value === 'modern') && quantity === 0) {
          return 'Plint geselecteerd - vul m² in of verfijn met lengte en breedte van de ruimte';
        }

        if (this.skirtingInput?.value === 'matching') {
          return `Plakplint bijpassend - ${quantity} lengtes x ${this.formatMoney(this.skirtingMatchingCents)}${calculationSuffix}`;
        }

        if (this.skirtingInput?.value === 'modern') {
          return `Hoge plint modern - ${quantity} lengtes x ${this.formatMoney(this.skirtingModernCents)}${calculationSuffix}`;
        }

        return 'Geen plint';
      }

      buildPackSummary(packs, deliveredArea) {
        if (!packs) return 'Je ontvangt 0 volledige pakken voor 0 m² geleverd.';
        return `Je ontvangt ${packs} volledige pakken voor ${this.formatNumber(deliveredArea)} m² geleverd.`;
      }

      buildBillableExplainer(billableArea, adjustedArea, deliveredArea) {
        if (!billableArea) return 'Je afrekening wordt gebaseerd op je invoer en het gekozen snijverlies.';
        if (deliveredArea > adjustedArea || billableArea > deliveredArea) {
          return `Je ontvangt ${this.formatNumber(deliveredArea)} m² in volledige pakken. Je betaalt voor ${billableArea} m², afgerond naar boven.`;
        }

        return `Je betaalt voor ${billableArea} m² op basis van je berekening en het gekozen snijverlies.`;
      }

      buildServiceStatus() {
        const activeServices = [
          this.heatingInput?.value === 'yes' || this.heatingInput?.value === 'request',
          this.installationInput?.value === 'yes',
          this.levelingInput?.value === 'yes',
          (this.skirtingInput?.value === 'matching' || this.skirtingInput?.value === 'modern') && this.getSkirtingQuantity() > 0,
          this.sealingInput?.value === 'yes',
        ].filter(Boolean).length;

        if (!activeServices) return "Geen extra's";
        if (activeServices === 1) return '1 optie actief';
        return `${activeServices} opties actief`;
      }

      buildDeliveryStatus(extraCosts) {
        if (this.deliveryInput?.value !== 'delivery') return 'Afhalen';
        if (this.deliveryPlacementInput?.value === 'inside') {
          return extraCosts.stairs > 0 ? `Binnen + ${extraCosts.stairs} trappen` : 'Binnen';
        }

        return 'Tot de deur';
      }

      buildSelectedOptionsSummary(extraCosts) {
        const labels = [];

        if (this.heatingInput?.value === 'yes') labels.push('Vloerverwarming');
        if (this.heatingInput?.value === 'request') labels.push('Vloerverwarming op aanvraag');
        if (this.installationInput?.value === 'yes') labels.push('Legservice');
        if (this.levelingInput?.value === 'yes') labels.push('Egaliseren');
        if (this.skirtingInput?.value === 'matching' && this.getSkirtingQuantity() > 0) labels.push(`Plakplint (${this.getSkirtingQuantity()} lengtes)`);
        if (this.skirtingInput?.value === 'modern' && this.getSkirtingQuantity() > 0) labels.push(`Hoge plint (${this.getSkirtingQuantity()} lengtes)`);
        if (this.sealingInput?.value === 'yes') labels.push('Afkitten');
        if (this.deliveryInput?.value === 'delivery') {
          labels.push(
            this.deliveryPlacementInput?.value === 'inside'
              ? `Bezorgen tot binnen (${extraCosts.stairs} trappen)`
              : 'Bezorgen tot de deur'
          );
        }

        return labels.length ? labels.join(', ') : 'Geen extra opties gekozen';
      }

      setProperty(input, enabled, value) {
        if (!input) return;
        input.disabled = !enabled;
        input.value = enabled ? value : '';
      }

      setText(node, value) {
        if (node) node.textContent = value;
      }

      applyServicePrices() {
        this.installationCentsPerM2 = this.getServicePrice('installation', this.installationCentsPerM2);
        this.levelingCentsPerM2 = this.getServicePrice('leveling', this.levelingCentsPerM2);
        this.skirtingMatchingCents = this.getServicePrice('skirtingMatching', this.skirtingMatchingCents);
        this.skirtingModernCents = this.getServicePrice('skirtingModern', this.skirtingModernCents);
        this.sealingCentsPerM2 = this.getServicePrice('sealing', this.sealingCentsPerM2);
        this.deliveryCents = this.getServicePrice('delivery', this.deliveryCents);
        this.stairCents = this.getServicePrice('stairs', this.stairCents);
      }

      getServicePrice(key, fallback) {
        const price = parseInt(this.serviceProducts?.[key]?.priceCents || '', 10);
        return Number.isNaN(price) ? fallback : price;
      }

      async addCalculatedItemsToCart(event) {
        if (this.isAddingToCart) return;

        this.isAddingToCart = true;
        this.setServiceError(false);
        this.setLoadingState(true);

        try {
          const items = await this.buildCartItems();
          await this.removeExistingBundleForCurrentProduct();
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const body = { items };

          if (cart) {
            body.sections = cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            cart.setActiveElement(document.activeElement);
          }

          const response = await fetch(this.getCartAddUrl(), {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(body),
          });
          const parsedState = await this.parseCartResponse(response);

          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || 'Kon de producten niet toevoegen.');
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!parsedState.key && parsedState.items?.[0]?.key) {
            parsedState.key = parsedState.items[0].key;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'm2-calculator',
            productVariantId: this.getBaseVariantId(),
            cartData: parsedState,
          });
          cart.renderContents(parsedState);
          CartPerformance.measureFromEvent?.('add:user-action', event);
        } catch (error) {
          console.error(error);
          this.setServiceError(true, error.message);
        } finally {
          this.isAddingToCart = false;
          this.setLoadingState(false);
        }
      }

      async buildCartItems() {
        const calculation = this.currentCalculation || {};
        const billableArea = calculation.billableArea || 0;
        const serviceArea = calculation.serviceArea || 0;
        const bundleContext = this.buildBundleContext(calculation);
        const items = [
          {
            id: this.getBaseVariantId(),
            quantity: billableArea,
            properties: this.getEnabledProperties(bundleContext),
          },
        ];

        if (this.installationInput?.value === 'yes') {
          items.push({
            id: this.getServiceVariantId('installation'),
            quantity: serviceArea,
            properties: this.getServiceProperties('Legservice inclusief lijm', 'installation', 'per_m2', bundleContext),
          });
        }

        if (this.levelingInput?.value === 'yes') {
          items.push({
            id: this.getServiceVariantId('leveling'),
            quantity: serviceArea,
            properties: this.getServiceProperties('Egaliseren inclusief materiaal', 'leveling', 'per_m2', bundleContext),
          });
        }

        if (this.skirtingInput?.value === 'matching' || this.skirtingInput?.value === 'modern') {
          const skirtingQuantity = this.getSkirtingQuantity();

          if (skirtingQuantity > 0) {
            const serviceKey = this.skirtingInput.value === 'matching' ? 'skirtingMatching' : 'skirtingModern';
            const childType = serviceKey === 'skirtingMatching' ? 'skirting_matching' : 'skirting_modern';
            items.push({
              id: this.getServiceVariantId(serviceKey),
              quantity: skirtingQuantity,
              properties: this.getServiceProperties(this.getSkirtingText(this.currentCalculation.extraCosts), childType, 'per_piece', bundleContext),
            });
          }
        }

        if (this.sealingInput?.value === 'yes') {
          items.push({
            id: this.getServiceVariantId('sealing'),
            quantity: serviceArea,
            properties: this.getServiceProperties('Afkitten', 'sealing', 'per_m2', bundleContext),
          });
        }

        if (this.deliveryInput?.value === 'delivery' && calculation.extraCosts?.deliveryBaseCents > 0) {
          items.push({
            id: this.getServiceVariantId('delivery'),
            quantity: 1,
            properties: this.getServiceProperties('Bezorging', 'delivery', 'fixed', bundleContext),
          });
        }

        if (this.deliveryInput?.value === 'delivery' && calculation.extraCosts?.stairs > 0) {
          items.push({
            id: this.getServiceVariantId('stairs'),
            quantity: calculation.extraCosts.stairs,
            properties: this.getServiceProperties('Trapservice', 'stairs', 'per_stair', bundleContext),
          });
        }

        return items;
      }

      buildBundleContext(calculation) {
        const childTypes = [];

        if (this.installationInput?.value === 'yes') childTypes.push('installation');
        if (this.levelingInput?.value === 'yes') childTypes.push('leveling');
        if ((this.skirtingInput?.value === 'matching' || this.skirtingInput?.value === 'modern') && this.getSkirtingQuantity() > 0) {
          childTypes.push(this.skirtingInput.value === 'matching' ? 'skirting_matching' : 'skirting_modern');
        }
        if (this.sealingInput?.value === 'yes') childTypes.push('sealing');
        if (this.deliveryInput?.value === 'delivery' && calculation.extraCosts?.deliveryBaseCents > 0) childTypes.push('delivery');
        if (this.deliveryInput?.value === 'delivery' && calculation.extraCosts?.stairs > 0) childTypes.push('stairs');

        return {
          id: this.generateBundleId(),
          label: this.dataset.productTitle || '',
          childTypes,
        };
      }

      generateBundleId() {
        return `floor-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      }

      getCartAddUrl() {
        const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
        return cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`;
      }

      getCartUrl() {
        const cartUrl = window.routes?.cart_url || '/cart';
        return cartUrl.endsWith('.js') ? cartUrl : `${cartUrl}.js`;
      }

      getCartUpdateUrl() {
        const cartUpdateUrl = window.routes?.cart_update_url || '/cart/update';
        return cartUpdateUrl.endsWith('.js') ? cartUpdateUrl : `${cartUpdateUrl}.js`;
      }

      async removeExistingBundleForCurrentProduct() {
        const baseVariantId = this.getBaseVariantId();
        if (!baseVariantId) return;

        const cartResponse = await fetch(this.getCartUrl(), {
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        });
        const cartState = await this.parseCartResponse(cartResponse);
        const matchingBundleIds = new Set();

        cartState.items?.forEach((item) => {
          const properties = item.properties || {};
          if (Number(item.variant_id) === baseVariantId && properties._bundle_role === 'parent' && properties._bundle_id) {
            matchingBundleIds.add(properties._bundle_id);
          }
        });

        if (!matchingBundleIds.size) return;

        const updates = {};
        cartState.items?.forEach((item) => {
          const properties = item.properties || {};
          if (matchingBundleIds.has(properties._bundle_id)) {
            updates[item.key] = 0;
          }
        });

        if (!Object.keys(updates).length) return;

        const updateResponse = await fetch(this.getCartUpdateUrl(), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ updates }),
        });
        const updatedCartState = await this.parseCartResponse(updateResponse);

        if (!updateResponse.ok || updatedCartState.status) {
          throw new Error(updatedCartState.description || updatedCartState.message || 'Kon de vorige vloerberekening niet bijwerken.');
        }
      }

      async parseCartResponse(response) {
        const responseText = await response.text();

        try {
          return JSON.parse(responseText);
        } catch (error) {
          throw new Error(
            response.ok
              ? 'Shopify gaf geen geldige cart response terug.'
              : `Shopify cart fout (${response.status}). Controleer of alle serviceproducten beschikbaar zijn.`
          );
        }
      }

      getBaseVariantId() {
        return Number(this.productForm?.querySelector('[name="id"]')?.value);
      }

      getEnabledProperties(bundleContext) {
        const properties = {};
        const propertyInputs = this.querySelectorAll('input[name^="properties["]');
        const floorLineProperties = new Set([
          'Gewenste m²',
          'Snijverlies',
          'Totaal m² incl. snijverlies',
          'Afrekenen m²',
          'Aantal pakken',
          'M² per pak',
          'Totaal geleverde m²',
          'Vloerverwarming',
          'Legservice',
          'Egaliseren',
          'Plinten',
          'Afkitten',
          'Bezorging of afhalen',
          'Bezorgoptie',
          'Aantal trappen',
          'Totaal vloerprijs',
          'Totaal legservice',
          'Totaal egaliseren',
          'Totaal plinten',
          'Totaal afkitten',
          'Totaal extra opties',
          'Totaal bezorging',
          'Totaal bezorging en trapservice',
          'Totaalprijs',
        ]);

        propertyInputs.forEach((input) => {
          if (input.disabled || !input.value) return;
          const propertyName = input.name.replace('properties[', '').replace(']', '');
          if (!floorLineProperties.has(propertyName)) return;
          properties[propertyName] = input.value;
        });

        if (bundleContext) {
          properties._bundle_id = bundleContext.id;
          properties._bundle_role = 'parent';
          properties._bundle_label = bundleContext.label;
          properties._bundle_children_expected = bundleContext.childTypes.join(',');
        }

        return properties;
      }

      getServiceProperties(label, childType, pricingModel, bundleContext) {
        return {
          _bundle_id: bundleContext?.id || '',
          _bundle_role: 'child',
          _bundle_parent_label: bundleContext?.label || this.dataset.productTitle || '',
          _bundle_child_type: childType,
          _bundle_child_pricing_model: pricingModel,
          'Onderdeel van': this.dataset.productTitle || '',
          _ProductURL: this.dataset.productUrl || window.location.href,
          _Service: label,
        };
      }

      getServiceVariantId(key) {
        const serviceProduct = this.serviceProducts?.[key];
        const variantId = Number(serviceProduct?.variantId);

        if (!variantId || Number.isNaN(variantId)) {
          throw new Error(`Serviceproduct niet gekoppeld of niet gevonden: ${serviceProduct?.handle || key}`);
        }

        return variantId;
      }

      setLoadingState(isLoading) {
        const productFormElement = this.productForm?.closest('product-form');
        const spinner = productFormElement?.querySelector('.loading__spinner');

        if (this.submitButton && !this.submitButtonInitiallyDisabled) {
          this.submitButton.toggleAttribute('aria-disabled', isLoading);
          this.submitButton.classList.toggle('loading', isLoading);
        }

        spinner?.classList.toggle('hidden', !isLoading);
      }

      setServiceError(show, message = '') {
        if (!this.serviceErrorMessage) return;
        this.serviceErrorMessage.hidden = !show;
        if (message) this.serviceErrorMessage.textContent = message;
      }

      formatNumber(value) {
        return new Intl.NumberFormat(this.locale, {
          maximumFractionDigits: 3,
        }).format(value);
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency,
        }).format(cents / 100);
      }
    }
  );
}
